import { HStack, useDisclosure } from '@chakra-ui/react';
import { faPencil, faThumbTack, faThumbTackSlash, faTrash, faTrashArrowUp } from '@fortawesome/free-solid-svg-icons';
import { EntityNoteModel } from '../../globalModels/entityNotes/entityNoteModel';
import { BaseTableIconButton } from '@invara-dev/react-base';
import { useEntityNoteMutation } from './apis/useEntityNoteMutation';
import { EntityNoteQueryType } from '../../enums/common/EntityNoteQueryType';
import { EntityNotesPopover } from '../../features/entityNotes/EntityNotesPopover.tsx';
import { PinNotePopover } from './PinNotePopover';

type Props = {
  typeId?: number;
  model: EntityNoteModel;
  queryType: EntityNoteQueryType;
  onPinnedChange: () => void;
  isReadOnly?: boolean;
};

export const EntityNotesControls = (props: Props) => {
  const createNoteMutation = useEntityNoteMutation();
  const noteDisclosure = useDisclosure();
  const pinDisclosure = useDisclosure();

  const onTogglePinned = () => {
    pinDisclosure.onOpen();
  };

  const onToggleDisabled = async (formModel: EntityNoteModel) => {
    props.model.IsDisabled = !props.model.IsDisabled;
    await createNoteMutation.mutateAsync({
      id: props.typeId,
      noteType: props.queryType,
      model: formModel
    });
  };

  if (props.isReadOnly) {
    return null;
  }

  return (
    <HStack gap={'5px'} margin={'5px'}>
      <EntityNotesPopover disclosure={noteDisclosure} id={props.typeId} model={props.model} queryType={props.queryType}>
        <BaseTableIconButton
          icon={faPencil}
          toolTip='Edit'
          onClick={() => {
            noteDisclosure.onOpen();
          }}
        />
      </EntityNotesPopover>

      <PinNotePopover
        disclosure={pinDisclosure}
        model={props.model}
        id={props.typeId}
        queryType={props.queryType}
        onPinned={props.onPinnedChange}>
        <BaseTableIconButton
          toolTip={props.model.IsPinned ? 'Unpin' : 'Pin to Top'}
          onClick={() => onTogglePinned()}
          icon={props.model.IsPinned ? faThumbTackSlash : faThumbTack}
        />
      </PinNotePopover>

      <BaseTableIconButton
        toolTip={props.model.IsDisabled ? 'Enable' : 'Disable'}
        onClick={() => onToggleDisabled(props.model)}
        icon={props.model.IsDisabled ? faTrashArrowUp : faTrash}
      />
    </HStack>
  );
};
